import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.boundResize = this.resize.bind(this)
    this.resize()
    this.element.addEventListener("input", this.boundResize)
  }

  disconnect() {
    this.element.removeEventListener("input", this.boundResize)
  }

  resize() {
    const scrollY = window.scrollY
    this.element.style.height = "auto"
    this.element.style.height = this.element.scrollHeight + "px"
    window.scrollTo(0, scrollY)
  }
}
